'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'

export const ModalFooter = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <footer className={cn('flex-initial flex flex-col gap-2', className)}>
    {children}
  </footer>
)
